import React, { useEffect } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap5';

import routes from 'app/routes';
import Table from 'components/new_ui/Table';
import { useContext } from 'components/Affiliates/Prospects/Context';

import confirmAlert from 'components/new_ui/Alerts/confirm';

import columns from './Table/columns';
import NoData from './Table/NoData';

export default function Main() {
  const { dispatch, state, actions } = useContext();

  const navigate = useNavigate();

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  const onEdit = (rowId) => {
    navigate(routes.affiliates.prospects.edit(rowId));
  };

  const onArchive = (rowId) => {
    confirmAlert({
      title: 'Archive Prospect',
      text: 'Are you sure that you want to archive this prospect?',
      confirmButtonText: 'Archive',
    }, () => {
      actions.delete(dispatch, rowId);
    });
  };

  const rowActions = [
    {
      title: 'Edit',
      type: 'CUSTOM',
      iconClass: 'edit-icon',
      onClick: (row) => { onEdit(row.id); },
    },
    {
      type: 'DIVIDER',
    },
    {
      title: 'Archive',
      type: 'CUSTOM',
      iconClass: 'trash-icon',
      onClick: (row) => { onArchive(row.id); },
    },
  ];

  return (
    <div className="content">
      <section>
        <Row>
          <Col>
            <h1>My Prospects</h1>
          </Col>

          <Col lg="auto">
            <Link
              to={routes.affiliates.prospects.calculator}
              className="btn btn-primary mt-3 mt-lg-0 me-3"
            >
              Talent Insurance Calc
            </Link>

            <Link
              to={routes.affiliates.prospects.new}
              className="btn btn-primary mt-3 mt-lg-0"
            >
              Add New Prospect
            </Link>
          </Col>
        </Row>
      </section>

      <section>
        <Table
          columns={columns}
          data={state.prospects || []}
          loading={state.prospects == null}
          rowActions={rowActions}
          noData={<NoData />}
          selectableRows={false}
        />
      </section>

      <Outlet />
    </div>
  );
}
